export default __webpack_public_path__ + "static/media/IMG_4050.5166b07a.JPG";